import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import events from './events'

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
      events
  }
})
